import React from "react";
import { LoaderContainer, Spinner } from "../styles";
import { useAppTranslation } from "../../locales/translate";

export const Loader = () => {
  const { t } = useAppTranslation();

  return (
    <LoaderContainer>
      <Spinner />
      <p>{t("LOADING_MODAL_TEXT")}</p>
    </LoaderContainer>
  );
};
